<template>
    <!-- section  -->				
    <section class="dark-bg sec-car scroll-con-sec" id="sec2">
        <div class="fet_pr-carousel_title fl-wrap">
            <div class="container">
                <div class="row">
                    <div class="col-md-8">
                        <h2>Featured <strong>Projects</strong></h2>
                        <p>{{ sectionSubtitle }}</p>
                    </div>
                    <div class="col-md-4">
                        <router-link to="/pages/projects" class="fet_pr-carousel_link btn">
                            View all Cases
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
        <!--grid-carousel-wrap -->
        <div class="grid-carousel-wrap fl-wrap">
            <div class="grid-carousel fl-wrap">
                <div class="swiper-container">
                    <div class="swiper-wrapper">
                        <!-- fet_pr-carousel-box  -->
                        <div class="swiper-slide" v-for="(category, index) in categories" :key="category.id">
                            <div class="fet_pr-carousel-box">
                                <div class="fet_pr-carousel-box-media fl-wrap">
                                    <div
                                        class="bg par-elem"
                                        :data-bg="category.featured_image"
                                        data-swiper-parallax="10%"
                                    ></div>
                                    <div class="overlay"></div>
                                    <div class="grid-det_category" v-if="category.contents_count">
                                        <a href="#">{{ category.contents_count }} project{{ category.contents_count === 1 ? '' : 's' }}</a>
                                    </div>
                                    <div class="grid-det_num">{{ String(index + 1).padStart(2, '0') }}.</div>
                                </div>
                                <div class="fet_pr-carousel-box-text fl-wrap">
                                    <router-link
                                        :to="`/projects/${category.slug}`"
                                    >{{ category.name }}</router-link>
                                </div>
                            </div>
                        </div>
                        <!-- fet_pr-carousel-box end -->
                    </div>
                </div>
            </div>
            <div class="grid-carousel_pagination"></div>
            <div class="gc-slider-cont gc-slider-cont-next">
                <i class="fal fa-angle-right"></i>
            </div>
            <div class="gc-slider-cont gc-slider-cont-prev">
                <i class="fal fa-angle-left"></i>
            </div>
        </div>
        <!--grid-carousel-wrap end -->							
    </section>
    <!-- section end-->
</template>

<script>
export default {
    name: 'FeaturedProjects',
    data() {
        return {
            sectionSubtitle: '',
            categories: [],
            gridCarousel: null
        }
    },
    async mounted() {
        await this.loadCategories()

        // Initialize Swiper after categories are loaded
        this.$nextTick(() => {
            setTimeout(() => {
                this.initSwiper()
            }, 100)
        })
    },
    beforeUnmount() {
        // Clean up Swiper instance
        if (this.gridCarousel) {
            this.gridCarousel.destroy(true, true)
            this.gridCarousel = null
        }
    },
    methods: {
        async loadCategories() {
            try {
                const response = await this.$api.get('public/content-types/projects/children')
                if (response.data) {
                    this.categories = response.data.data || []
                    console.log('✅ Loaded project categories:', this.categories.length)
                }
            } catch (error) {
                console.error('❌ Failed to load project categories:', error)
            }
        },

        initSwiper() {
            // Don't initialize if no categories or already initialized
            if (this.gridCarousel || this.categories.length === 0) return

            console.log('🎬 Initializing Featured Projects Swiper with', this.categories.length, 'categories')
            
            const $ = window.jQuery
            const Swiper = window.Swiper
            
            if (!$ || !Swiper) {
                console.error('❌ jQuery or Swiper not loaded')
                return
            }
            
            // Process data-bg attributes BEFORE Swiper initializes
            console.log('🖼️ Processing project background images...')
            $('.grid-carousel .bg[data-bg]').each(function() {
                const bg = $(this).attr('data-bg')
                if (bg) {
                    $(this).css('background-image', 'url(' + bg + ')')
                    console.log('  ✅ Set background:', bg)
                }
            })
            
            // Initialize Swiper
            this.gridCarousel = new Swiper(".grid-carousel .swiper-container", {
                preloadImages: true,
                loop: true,
                centeredSlides: true,
                freeMode: false,
                slidesPerView: 2,
                spaceBetween: 10,
                grabCursor: true,
                mousewheel: false,
                parallax: true,
                speed: 1400,
                navigation: {
                    nextEl: '.gc-slider-cont-next',
                    prevEl: '.gc-slider-cont-prev',
                },
                pagination: {
                    el: '.grid-carousel_pagination',
                    clickable: true,
                },
                breakpoints: {
                    768: {
                        slidesPerView: 2,
                    },
                    640: {
                        slidesPerView: 1,
                    },
                }
            })
            
            // Force update after a brief delay to ensure images are set
            setTimeout(() => {
                if (this.gridCarousel) {
                    this.gridCarousel.update()
                    console.log('🔄 Featured Projects Swiper updated')
                }
            }, 200)
            
            console.log('✅ Featured Projects Swiper initialized')
        },
        
        parseCategories(categories) {
            if (Array.isArray(categories)) {
                return categories.map(cat => cat.name || cat).slice(0, 2)
            } else if (typeof categories === 'string') {
                return categories.split(',').map(cat => cat.trim()).slice(0, 2)
            }
            return ['Interior', 'Architecture']
        }
    }
}
</script>

